import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const ChecklistsRoute: Route = {
  path: AppUrls.Dashboard._.Guide._.Checklists.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Guide._.Checklists._.ChecklistList.relativeUrl,
      pathMatch: 'full',
      loadComponent: () => import('./checklist-list/checklist-list.component').then(_ => _.ChecklistListComponent),
    },
    {
      path: AppUrls.Dashboard._.Guide._.Checklists._.ChecklistEditor.relativeUrl,
      loadComponent: () => import('./checklist-editor/checklist-editor.component').then(_ => _.ChecklistEditorComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Guide._.Checklists._.ChecklistList.relativeUrl,
    },
  ],
};
